import { SecretState } from './types';

export const insertNewLines = (string: string): string => {
  return string.replaceAll('","', '",\n    "').replace('{', '{\n    ').replace('"}', '"\n}');
};

export const SECRET_ALPHABET = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const LONG_TOKEN_LIFETIME_THRESHOLD = 432000;

export const isLongTokenLifetime = (tokenLifetime: number | undefined): boolean =>
  (tokenLifetime ?? 0) > LONG_TOKEN_LIFETIME_THRESHOLD;

export const isSaveDisabled = (state: SecretState): boolean => {
  const isKeyChanged = Boolean(state.newHMAC || state.newRSA);
  const isPristine =
    !isKeyChanged &&
    state.selectedSignature === state.initialSignature &&
    state.initialTokenLifetime === state.tokenLifetime;

  return (
    isPristine ||
    (isLongTokenLifetime(state.tokenLifetime) && !state.agreeLongToken) ||
    Boolean(state.tokenLifetimeError)
  );
};
